/**
 * Единая страница тарифов для всего продукта.
 */
export function usePricingPath(): string {
  return "/pricing";
}
